import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealComponent } from './deal.component';
import { DealsDetailsComponent } from './deals-details/deals-details.component';
import { CampaignResolver } from 'src/app/resolvers';
import { FeaturedProductDetailsComponent } from './featured-product-details/featured-product-details.component';

const routes: Routes = [

  {
    path: "details", component: DealsDetailsComponent,
    data: {
      title: '',
      description: '',
      url: '',
      image: '',
    },
    resolve: {
      campaign: CampaignResolver
    }
  },
  { path: "", component: DealComponent },
  { path: "organization", component: DealComponent },
  { path: "store", component: DealComponent },
  {  path: "featured-product-details/:id", component: FeaturedProductDetailsComponent },
  { path: ":storeId", component: DealComponent },
  {  path: ":storeId/featured-product-details/:id", component: FeaturedProductDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class DealRoutingModule { }